<template>
  <div class="logItemForm">

    <!--  Select log type  -->
    <div class="logEntryPills">
      <b-badge class="logTypePill" href="#" @click="setLogType('note')" :variant="logItem.logType == 'note' ? 'secondary': 'light'">
        Note
      </b-badge>
      <b-badge id="actionPill" href="#" @click="setLogType('action')"  :variant="logItem.logType == 'action' ? 'secondary': 'light'">
        Action
      </b-badge>
      <b-badge id="decisionPill" href="#" @click="setLogType('decision')"  :variant="logItem.logType == 'decision' ? 'secondary': 'light'">
        Decision
      </b-badge>
    </div>


    <!--  Note  -->
    <div  fluid v-if="logItem.logType == 'note'">
      <!-- <b-input-group>
      <b-input-group-append></b-input-group-append>
      </b-input-group> -->
      <b-form-textarea Xclass="logInput" Xautofocus id="textarea1" placeholder="What do you want to make a note of?" rows="2" max-rows="6" v-model="logItem.text" @keyup.enter.native="postLogItem">
      </b-form-textarea>
      <b-btn size="sm" style="margin-top:0.2rem; float: right" @click="postLogItem">Save Note</b-btn>
    </div>

    <!--  Decision -->
    <div xclass="logItemForm" v-if="logItem.logType == 'decision'">
      <b-input-group>
        <b-form-textarea id="textarea1" placeholder="What did you decide?" rows="1" max-rows="6" v-model="logItem.text" @Xkeyup.enter.native="insertLog(item.id)">
        </b-form-textarea>
        <b-input-group-append></b-input-group-append>
      </b-input-group>
      <b-btn size="sm" @click="postLogItem" style="margin-top:0.2rem; float: right">Save Decision</b-btn>
    </div>

    <!--  Action  -->
     <b-container fluid v-if="logItem.logType == 'action'" style="padding:0">
       <b-row no-gutters>
         <b-col cols="12">
            <b-form-textarea id="textarea1" placeholder="What needs doing?" rows="1" max-rows="6" v-model="logItem.text"></b-form-textarea>
         </b-col>
       </b-row>
       <b-row style="margin-top:0.5rem; padding: 0" no-gutters>
         <b-col cols="6">
           <vue-bootstrap-typeahead inputClass="InputActionOwner" :id="'actionOwner'" ref="actionOwner" XXv-model="actionOwnerName" placeholder="Who will do it?" :data="attendees" :xdata="attendees.map(x => x.name)" @hit="logItem.owner={name:$event.name, email:$event.email}" :serializer="item => item.name" :minMatchingChars="1" />
         </b-col>
         <b-col cols="6">
           <!-- <b-form-input width="6" placeholder="due date" type="date"  v-model="logItem.date"></b-form-input> -->
           <v-date-picker v-model="logItem.date"
            @Xdayclick="setActionDate($event)" :attributes="calAttributes"
           :input-props='{
              placeholder: "By what date?",
              id: "selectActionDate"
            }'
           />
          </b-col>
        </b-row>
        <b-row>
        <b-col cols="12"><b-btn size="sm" @click="postLogItem" style="float:right;margin-top:0.2rem">Save Action</b-btn></b-col>
      </b-row>

    </b-container>
    <!--  Select log type  -->
    <!-- <div class="logEntryPills">
      <b-badge class="logTypePill" href="#" @click="setLogType('note')" :variant="logItem.logType == 'note' ? 'secondary': 'light'">
        Note
      </b-badge>
      <b-badge id="actionPill" href="#" @click="setLogType('action')"  :variant="logItem.logType == 'action' ? 'secondary': 'light'">
        Action
      </b-badge>
      <b-badge id="decisionPill" href="#" @click="setLogType('decision')"  :variant="logItem.logType == 'decision' ? 'secondary': 'light'">
        Decision
      </b-badge>
    </div> -->

  </div>
</template>
<script>
export default {
  props: ['mode', 'agendaItem', 'attendees'],
  data () {
    return {
      // agendaItem: this.agendaItem,
      // attendees: this.attendees,
      // logItem: {logType: 'note', text: '', owner: '', date: this.$moment().add(3, 'd').format('YYYY-MM-DD')},
      logItem: {logType: 'note', text: '', owner: '', date: ''},
      calAttributes: [{
           key: 'today',
           dot: true,
           dates: new Date(),
        }]
    }
  },
  computed: {
    actionOwnerName () {
      return this.logItem.owner ?  this.logItem.owner.name : ''
    }
  },
  methods: {
    setActionDate (event) {
      console.log(event)
      this.logItem.date = this.$moment(event.id).format('YYYY-MM-DD')
    },
    postLogItem () {
      this.logItem.agendaItemId = this.agendaItem.id
      this.$emit('postLogItem', this.logItem)
      this.logItem.text=''
      this.logItem.date=''
      this.$refs.actionOwner.inputValue = ''
    },
    setLogType (logType) {
      this.logItem.logType = logType
    },
    cancelEditItem () {
      this.agendaItem.topic = ''
      this.agendaItem.objective = ''
      this.agendaItem.owner = this.user.displayName
      this.agendaItem.duration = '15'
      this.editAgendaIndex = -1
    }
  }
}
</script>
<style scoped>
  .card{width:90%;margin-bottom:15px}
  .logInput.form-control{background-color: var(--lightGray)}
  .logItemForm {background-color: var(--lightGray); Xpadding: 0.5rem 0.5rem 0.9rem 0.5rem; border-radius: 5px; display: flex; flex-direction: column; Xalign-items: flex-end;}
  .badge.logTypePill {}
  .logEntryPills {margin-bottom: 0.2rem; Xmargin-top:-2.2rem;z-index: 10; margin-left:0.1rem; max-width: 20rem}
  .calToday {background-color: pink}
</style>
